<template>
  <ConfirmationDialog
    id="auth-dialog"
    :show-dialog="rootStore.timeoutMenu"
    :text="$t('label.sessionTimeOut')"
    :confirm-text="$t('account.signin')"
    :width="360"
    :action-function="login"
    @close="logout"
  />
</template>

<script lang="ts" setup>
import ConfirmationDialog from '~/components/base/ConfirmationDialog.vue'
import { useAuthStore } from '~/stores/auth'
import { useRootStore } from '~/stores/root'

const rootStore = useRootStore()
const authStore = useAuthStore()

const redirectHome = ref(true)
const { logout: logoutAction, isAgentOrImpersonating } = useSAuth()
const router = useRouter()
const login = () => {
  redirectHome.value = false
  if (isAgentOrImpersonating.value) {
    router.push('/agent/sign-in')
    return
  }
  authStore.updateAuthMenu(true)
}

const logout = async () => {
  if (!authStore.authMenu && rootStore.timeoutMenu) {
    rootStore.updateTimeoutMenu(false)
    await logoutAction(redirectHome.value)
    redirectHome.value = true
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-dialog) {
  max-width: 380px;
}
</style>
